import { OutboundMessageStatus } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { theme } from '@frontend/theme';
import {
  defaultGroupedStatusMap,
  failedGroupedStatuses,
  groupedStatusColorTones,
  groupedStatusDisplayLabels,
  successfulGroupedStatuses,
  type MessageStatusColorTone,
} from './status-metadata';

type MessageStatusColors = {
  backgroundColor: string;
  textColor: string;
};

const statusColorByTone: Record<MessageStatusColorTone, MessageStatusColors> = {
  critical: { backgroundColor: theme.colors.critical10, textColor: theme.colors.critical70 },
  eggplant: { backgroundColor: theme.colors.secondary.eggplant10, textColor: theme.colors.secondary.eggplant70 },
  indigo: { backgroundColor: theme.colors.indigo10, textColor: theme.colors.indigo70 },
  neutral: { backgroundColor: theme.colors.neutral20, textColor: theme.colors.neutral70 },
  neutralMuted: { backgroundColor: theme.colors.neutral10, textColor: theme.colors.neutral30 },
  neutralStrong: { backgroundColor: theme.colors.neutral20, textColor: theme.colors.neutral90 },
  primary: { backgroundColor: theme.colors.primary10, textColor: theme.colors.primary70 },
  tangerine: { backgroundColor: theme.colors.tangerine10, textColor: theme.colors.tangerine70 },
  warning: { backgroundColor: theme.colors.warning5, textColor: theme.colors.warning60 },
};

// TODO: we should eventually move this to the BE so that it can be better maintained
export const getMessageStatusColors = (status: OutboundMessageStatus) => {
  const groupedStatus = defaultGroupedStatusMap[status] ?? status;
  const tone = groupedStatusColorTones[groupedStatus] ?? 'tangerine';
  return statusColorByTone[tone];
};

export { defaultGroupedStatusMap, failedGroupedStatuses, groupedStatusDisplayLabels, successfulGroupedStatuses };
